import React from "react";
import { connect } from "react-redux";
import { Dropdown, Input, Menu } from "antd";
import _ from "lodash";

import { CloseOutlined } from "@ant-design/icons";
import CustomTag from "components/ui/CustomTag";
import NavigationFooter from "components/footers/NavigationFooter";
import { getCategory, searchAttributes } from "utils/helpers";
import MasterButton, {
  BUTTON_TYPES,
  BackButton,
} from "components/ui/MasterButton";
import AlphaList from "components/attribute/AlphaList";
import NotFound from "components/attribute/NotFound";
import { makeAttributeSelector } from "reducers/selectors";
import "styles/AttributeCategory.scss";
const MenuItem = Menu.Item;
// import CATEGORIES from "utils/categories"; due to circular reference
const { Search } = Input;
export default function asAttributeCategory({
  ATTRIBUTE_ACTIONS,
  title,
  descriptiveTitle,
  prompt,
  nextCategory,
  placeholder,
}) {
  class InnerClass extends React.Component {
    constructor(props) {
      super(props);
      const { userAttributes } = props;
      this.state = {
        search: "",
        touchedTags: [...userAttributes],
        list: false,
      };
    }

    componentDidMount = () => {
      // append data-hj-whitelist class onto input element
      let inputElement = document.getElementsByTagName("input");
      if (inputElement && inputElement.length) {
        inputElement[0].classList.add("data-hj-whitelist");
      } else {
        console.error(
          "Could not add `data-hj-whitelist` to input element for hotjar."
        );
      }
      window.scrollTo(0, -100);
    };

    handleSearch = (ev) => {
      this.setState({ search: ev.target.value });
    };

    handleClickNotFound = () => {
      this.setState({ search: "" });
      this.toggleView();
    };

    toggleTag = (raw) => {
      const value = raw.toString();
      this.props.dispatch({
        type: ATTRIBUTE_ACTIONS.TOGGLE,
        data: value,
      });
      this.setState({
        search: "",
      });
      const { touchedTags } = this.state;
      if (touchedTags.includes(value)) {
      } else {
        this.setState({
          touchedTags: touchedTags.concat([value]),
        });
      }
    };

    toggleView = () => {
      this.setState({ list: !this.state.list });
    };

    clearAll = () => {
      this.props.dispatch({
        type: ATTRIBUTE_ACTIONS.RESET,
      });
      this.setState({ search: "" });
    };

    renderList = () => {
      const { attributes, userAttributes } = this.props;
      const list = attributes.map((attri) => ({
        ...attri,
        selected: userAttributes.includes(attri.attribute_id.toString()),
      }));
      return (
        <>
          <BackButton onClick={this.toggleView} />
          <h1>All {title}</h1>
          <p>Select the options that best match your interests</p>
          <AlphaList list={list} toggleTag={this.toggleTag} />
        </>
      );
    };

    renderSearch = () => {
      const { attributes, userAttributes, attributeRef } = this.props;

      const { search, touchedTags } = this.state;
      const filteredOptions = search
        ? attributes
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .filter((attri) => searchAttributes(search, attri.name))
        : [];

      const menu = (
        <Menu>
          {_.isEmpty(search) && !filteredOptions.length ? (
            <MenuItem key="na-menu-item">
              <div></div>
            </MenuItem>
          ) : (
            <MenuItem key="menu-item">
              <div className="attribute-search-dropdown">
                {filteredOptions.length ? (
                  <div>
                    <div className="label-text">Select relevant tags</div>
                    {filteredOptions.map(({ attribute_id, name }) => {
                      const id = attribute_id.toString();
                      return (
                        <CustomTag
                          key={id}
                          value={id}
                          onChange={() => this.toggleTag(id)}
                          checked={userAttributes.includes(id)}
                        >
                          {name}
                        </CustomTag>
                      );
                    })}
                  </div>
                ) : (
                  <NotFound
                    heading={`${title} not found`}
                    buttonText={`our list of ${descriptiveTitle.toLowerCase()}`}
                    callback={this.handleClickNotFound}
                  />
                )}
              </div>
            </MenuItem>
          )}
        </Menu>
      );

      const visible = search ? true : false;
      return (
        <>
          <div className="flex-space-between">
            <h1 style={{ maxWidth: 400 }}>{prompt}</h1>
            <div className="desktop-and-tablet">
              <MasterButton
                type={BUTTON_TYPES.TERTIARY}
                text={`View All ${descriptiveTitle}`}
                callback={this.toggleView}
              />
            </div>
          </div>

          <div className="mobile-only">
            <MasterButton
              type={BUTTON_TYPES.TERTIARY}
              text={`View All ${descriptiveTitle}`}
              callback={this.toggleView}
              style={{ margin: "20px 0px" }}
              wide={true}
            />
          </div>
          <label className="title" htmlFor="search-bar">
            {title}
          </label>
          <div className="selected-tags-container">
            {touchedTags.map((key) => {
              const checked = userAttributes.includes(key);
              return (
                <CustomTag
                  key={key}
                  value={key}
                  onChange={() => this.toggleTag(key)}
                  checked={checked}
                >
                  {attributeRef[key].name}
                  {checked ? <CloseOutlined className="close" /> : null}
                </CustomTag>
              );
            })}
          </div>
          <div className="select-and-clear">
            <Dropdown overlay={menu} open={visible}>
              <Search
                value={search}
                id="search-bar"
                className="attribute-search-bar"
                onChange={this.handleSearch}
                placeholder={placeholder}
              />
            </Dropdown>
            {userAttributes.length ? (
              <div className="desktop-and-tablet">
                <MasterButton
                  text="Clear"
                  callback={this.clearAll}
                  type={BUTTON_TYPES.CLEAR}
                  style={{ height: 40 }}
                />
              </div>
            ) : null}
          </div>
          <div className="mobile-only">
            <MasterButton
              text="Clear selection"
              callback={this.clearAll}
              type={BUTTON_TYPES.CLEAR}
              style={{ height: 40 }}
              wide={true}
            />
          </div>
        </>
      );
    };

    render() {
      const { list } = this.state;
      return (
        <>
          <div className="regular-padding">
            {list ? this.renderList() : this.renderSearch()}
          </div>
          <NavigationFooter
            list={list}
            onBack={() => this.setState({ list: false })}
            nextNavlink={getCategory(nextCategory).navlink}
            onSkip={this.clearAll}
          />
        </>
      );
    }
  }

  const mapStateToProps = (store) => (store) =>
    makeAttributeSelector(ATTRIBUTE_ACTIONS.ACCESS)(store);
  return connect(mapStateToProps)(InnerClass);
}
